
import CommonUtil from "./commonUtil.js";
import { apiSaveFileAccessLog} from "./api.js";
import authHeader from "../services/auth-header";


const AWS = require('aws-sdk')

//測試區
// var albumBucketName = "incx-ap-ctims-dev-file";
// var bucketRegion = "ap-northeast-1";
// var IdentityPoolId = "ap-northeast-1:c7809b16-61a2-4087-8789-e38431933334";
// var urlPath = "https://s3.ap-northeast-1.amazonaws.com/incx-ap-ctims-dev-file/cust/";

//正式區
var albumBucketName = "incx-ap-ctims-prd-file";
var bucketRegion = "ap-northeast-1";
var IdentityPoolId = "ap-northeast-1:c4d6ca68-5e29-4dd4-b17e-926087675246";
var urlPath = "https://s3.ap-northeast-1.amazonaws.com/incx-ap-ctims-prd-file/cust/";


AWS.config.update({
  region: bucketRegion,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: IdentityPoolId
  })
});

var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: albumBucketName },
  httpOptions: {
		timeout: 30*1000*60,
	},
});


class AWSUtil {
  getAlbumBucketName(){   
    return albumBucketName;
  }

  getBucketRegion(){    
    return bucketRegion;
  }

  getIdentityPoolId(){    
    return IdentityPoolId;
  }

  getUrlPath(){    
    return urlPath;
  }

  downloadDoc(uploadType, docId, subFolder, fileName, attachId){

    var folder = 'cust/'+uploadType+'/' + docId +'/'+  (CommonUtil.isNull(subFolder) ? '' : subFolder+'/')+fileName;
    const getFile = s3.getObject({Bucket: albumBucketName, Key: folder}).promise();
    var mask = document.getElementsByClassName('el-loading-mask is-fullscreen')[0];
    mask.style.display = "block";
    getFile.then(
      data => {   
        var mask = document.getElementsByClassName('el-loading-mask is-fullscreen')[0];
        mask.style.display = "none";
        const url = window.URL.createObjectURL(new Blob([data.Body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click();
        this.saveFileAccessLog(attachId);
      },
      err => {
        var mask = document.getElementsByClassName('el-loading-mask is-fullscreen')[0];
        mask.style.display = "none";
        return alert("There was an error downloading your file: ", err.message);    
      }
    )

  }
  downloadDocNoDocId(uploadType, subFolder, fileName, attachId){

    var folder = 'cust/'+uploadType+'/' +  (CommonUtil.isNull(subFolder) ? '' : subFolder+'/')+fileName;
    const getFile = s3.getObject({Bucket: albumBucketName, Key: folder}).promise();
    var mask = document.getElementsByClassName('el-loading-mask is-fullscreen')[0];
    mask.style.display = "block";
    getFile.then(
      data => {
        var mask = document.getElementsByClassName('el-loading-mask is-fullscreen')[0];
        mask.style.display = "none";
        const url = window.URL.createObjectURL(new Blob([data.Body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click();
        this.saveFileAccessLog(attachId);
      },
      err => {
        var mask = document.getElementsByClassName('el-loading-mask is-fullscreen')[0];
        mask.style.display = "none";
        return alert("There was an error downloading your file: ", err.message);
      }
    )
  }
    
  saveFileAccessLog(attachId){
    apiSaveFileAccessLog({ headers: authHeader(), attachId : attachId}).then((response) => {   
    }).catch((err) => {
      console.log(err);
    }); 
  }
    
}





export default new AWSUtil();
